module.exports = __webpack_public_path__ + "static/media/iceland.56a17dea.png";